import React, { useEffect, useState } from 'react';
import { getDoc } from 'firebase/firestore';
import { statRef } from './annotationStore';
import './SenseCount.css';

/**
 * SenseCount — how many annotations link to a yasna sense (its place in the
 * usage ranking, Requirement 30). Teacher-facing only: never render it on
 * the student page.
 *
 * Re-reads when `senseId` or `refreshKey` changes.
 */
function SenseCount({ senseId, refreshKey }) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    if (!senseId) return undefined;
    let cancelled = false;
    getDoc(statRef(senseId)).then(
      (snap) => { if (!cancelled) setCount(snap.exists() ? snap.data().annotationCount || 0 : 0); },
      () => { /* counts are informational; show nothing */ }
    );
    return () => { cancelled = true; };
  }, [senseId, refreshKey]);

  if (count === null) return null;
  return (
    <span className="sense-count" title="How many times this meaning has been annotated">
      {count > 0 ? `annotated ${count}×` : 'not annotated yet'}
    </span>
  );
}

export default SenseCount;
